import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

import { LinkButton } from '../../core/interfaces/dialog';

/**
 * Reusable confirmation dialog that displays a title, message, and configurable action buttons.
 * Supports an optional link button that navigates the user to a specified route on click.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'qiasphere-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
  imports: [MatDialogTitle, MatIcon, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class GenericDialogComponent {
  private readonly router = inject(Router);
  dialogRef = inject<MatDialogRef<GenericDialogComponent>>(MatDialogRef);
  data = inject<{
    icon: string;
    title: string;
    message: string;
    cancelButtonText: string;
    confirmButtonText: string;
    linkButton: LinkButton;
  }>(MAT_DIALOG_DATA);

  public redirect() {
    this.router.navigate([this.data.linkButton.link]);
  }
}
